<template>
  <section class="insured-vehicle-form">
    <h2 v-if="formData.class_id == 14">Insured Motorcycle Details</h2>
    <h2 v-if="formData.class_id == 11">Insured Private Details</h2>
    <h2 v-if="formData.class_id == 12">Insured Commercial Vehicle  Details</h2>

    <el-form
      ref="form"
      :rules="rules"
      :disabled="disabled"
      :model="formData">
      <div class="flex-sb">
        <div class="form-left form-half">
          <div class="form-item">
            <span>Is this Vehicle registered under the applicant now ? </span>
            <el-form-item
              ref="already_owned_by_ind"
              :rules="rules.select"
              prop="already_owned_by_ind">
              <v-radio-group
                v-model="formData.already_owned_by_ind"
                border
                :list="yesNoOptions"
                @change="handleOwned"/>
            </el-form-item>
          </div>
          <template v-if="formData.class_id === 14">
            <div
              class="form-item">
              <span>Registration Mark</span>
              <el-form-item
                ref="rgtn_no"
                prop="rgtn_no"
              >
                <v-input
                  v-model="formData.rgtn_no"
                  :uppercase="true"
                  maxlength="8"
                  type="text"/>
              </el-form-item>
            </div>
            <!--            <div class="form-item">-->
            <!--              <span>Car Type</span>-->
            <!--              <el-form-item prop="class_id">-->
            <!--                <v-select-->
            <!--                  v-model="formData.class_id"-->
            <!--                  :disabled="true"-->
            <!--                  :list="motorClassOptions" />-->
            <!--              </el-form-item>-->
            <!--            </div>-->
            <div class="form-item">
              <span>Make</span>
              <el-form-item
                ref="brand_id"
                :prop="isRequired?'brand_id':''">
                <v-select
                  v-model="formData.brand_id"
                  :disabled="isMotorcycle"
                  :list="localAllOptions.brand" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Model</span>
              <el-form-item
                ref="rgtn_mdl"
                prop="rgtn_mdl">
                <v-input
                  v-model="formData.rgtn_mdl"
                />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Body Type</span>
              <el-form-item
                ref="typ_of_bdy_id"
                prop="typ_of_bdy_id">
                <v-select
                  v-model="formData.typ_of_bdy_id"
                  :disabled="isMotorcycle"
                  :list="localAllOptions.typ_of_bdy" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Year of Manufacture</span>
              <el-form-item
                ref="rgtn_yr"
                prop="rgtn_yr">
                <v-select
                  v-model="formData.rgtn_yr"
                  :disabled="isMotorcycle"
                  :list="localAllOptions.rgtn_yr"
                />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Cylinder Capacity </span>
              <el-form-item
                ref="engn_cpcty"
                prop="engn_cpcty">
                <v-input
                  v-model="formData.engn_cpcty"
                  :min="0"
                  :max="99999"
                  type="number"
                  :int="true"
                  :keyNumber="true"
                  append="cc"/>
              </el-form-item>
            </div>
          </template>
          <template v-else-if="formData.class_id !== 14">
            <div
              class="form-item">
              <span>Registration Mark</span>
              <el-form-item
                ref="rgtn_no"
                prop="rgtn_no"
              >
                <v-input
                  v-model="formData.rgtn_no"
                  maxlength="8"
                  :uppercase="true"
                  type="text"/>
              </el-form-item>
            </div>

            <div class="form-item">
              <span>Make</span>
              <el-form-item
                ref="brand_id"
                prop="brand_id">
                <v-select
                  v-model="formData.brand_id"
                  :disabled="isPrivate"
                  :list="localAllOptions.brand"
                />
              </el-form-item>
            </div>
            <div
              v-if="formData.class_id === 12"
              class="form-item">
              <span>Model</span>
              <el-form-item
                ref="rgtn_mdl"
                prop="rgtn_mdl">
                <v-input
                  v-model="formData.rgtn_mdl" />
              </el-form-item>
            </div>
            <template v-else>
              <div
                class="form-item">
                <span>Model</span>
                <el-form-item
                  ref="model_id"
                  prop="model_id">
                  <v-select
                    v-model="formData.model_id"
                    :disabled="isPrivate"
                    :list="carModelOptions"
                    @change="handlerExtraModel" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span class="padding-bottom-0">Model Name</span>
                <span class="span-tips">Exact Match with Vehicle Registration Document</span>
                <el-form-item
                  ref="rgtn_mdl"
                  prop="rgtn_mdl">
                  <v-input
                    v-model="formData.rgtn_mdl"
                    uppercase
                  />
                </el-form-item>
              </div>
            </template>
            <div class="form-item">
              <span>Year of Manufacture</span>
              <el-form-item
                ref="rgtn_yr"
                prop="rgtn_yr">
                <v-select
                  v-model="formData.rgtn_yr"
                  :disabled="isPrivate"
                  :list="classId==11?carYearRelationList:localAllOptions.rgtn_yr"
                  @change="getCarRelation" />
              </el-form-item>
            </div>
            <div
              v-if="formData.class_id != 12"
              class="form-item">
              <span>Body Type</span>
              <el-form-item
                ref="typ_of_bdy_id"
                :prop="isRequired?'typ_of_bdy_id':''">
                <v-select
                  v-model="formData.typ_of_bdy_id"
                  :disabled="isPrivate"
                  disableKey="is_show"
                  :list="localAllOptions.typ_of_bdy" />
              </el-form-item>
            </div>
            <div
              v-else
              class="form-item">
              <span>Body Type</span>
              <el-form-item
                ref="typ_of_bdy_id"
                prop="typ_of_bdy_id">
                <!--                v-model="formData.rgtn_typ_of_bdy"-->
                <v-select
                  v-model="formData.typ_of_bdy_id"
                  :list="bodyTypeList"
                />
              </el-form-item>
            </div>

            <div
              v-if="!isElectric"
              class="form-item">
              <span v-if="formData.class_id==11">Cylinder Capacity</span>
              <span v-else>Cylinder Capacity (Input "0" for EV)</span>
              <el-form-item
                v-if="formData.class_id!=11"
                ref="engn_cpcty"
                :prop="editType == 2?'engn_cpcty' : ''">
                <v-input
                  v-model="formData.engn_cpcty"
                  :min="0"
                  :max="99999"
                  type="number"
                  :int="true"
                  :keyNumber="true"
                  append="cc"/>
              </el-form-item>
              <el-form-item
                v-else
                ref="engn_cpcty"
                :prop="editType == 2?'engn_cpcty' : ''">
                <v-input-select
                  v-model="formData.engn_cpcty"
                  :list="carRelationList"
                  :keyNumber="true"
                  :min="0"
                  :max="99999"
                  can-select
                  append="cc"/>
              </el-form-item>
            </div>
            <div
              v-if="formData.class_id === 11"
              class="form-item">
              <span>Seating Capacity ( excl. driver)</span>
              <el-form-item
                ref="no_of_seats"
                prop="no_of_seats">
                <v-input
                  v-model="formData.no_of_seats"
                  :min="1"
                  :max="9"
                  :keyNumber="true"
                  :int="true"
                />
              </el-form-item>
            </div>
          </template>
        </div>
        <div class="form-right form-half">
          <template v-if="formData.class_id === 14">
            <div class="form-item">
              <span>Seating Capacity ( excl. driver)</span>
              <el-form-item
                ref="no_of_seats"
                prop="no_of_seats">
                <v-input
                  v-model="formData.no_of_seats"
                  :min="0"
                  :max="2"
                  :keyNumber="true"
                  :int="true"/>
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Chassis Number</span>
              <el-form-item
                ref="chasis_no"
                prop="chasis_no">
                <v-input
                  v-model="formData.chasis_no"
                  :uppercase="true"/>
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Engine Number</span>
              <el-form-item
                ref="engn_no"
                prop="engn_no">
                <v-input
                  v-model="formData.engn_no"
                  :uppercase="true"/>
              </el-form-item>
            </div>
            <!--            <div class="form-item">-->
            <!--              <span>Insurance Type</span>-->
            <!--              &lt;!&ndash;              :disabled="disabledList.includes('trm_of_cvr')"&ndash;&gt;-->
            <!--              <el-form-item prop="trm_of_cvr">-->
            <!--                <v-select-->
            <!--                  v-model="formData.trm_of_cvr"-->
            <!--                  :disabled="disabledList.includes('trm_of_cvr')"-->
            <!--                  :list="coverTypeOptions" />-->
            <!--              </el-form-item>-->
            <!--            </div>-->
            <div class="form-item">
              <span>Is there any modification in the above vehicle?</span>
              <el-form-item
                ref="car_modified_ind"
                prop="car_modified_ind">
                <v-radio-group
                  v-model="formData.car_modified_ind"
                  :border="true"
                  :list="modifiedOptions" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Is the vehicle fitted with Car Camcorder?</span>
              <el-form-item
                ref="car_camcorder_ind"
                prop="car_camcorder_ind">
                <v-radio-group
                  v-model="formData.car_camcorder_ind"
                  :border="true"
                  :list="installOptions" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Will the vehicle be used for commercial purpose?</span>
              <el-form-item
                ref="usage_ind"
                prop="usage_ind">
                <v-radio-group
                  v-model="formData.usage_ind"
                  :border="true"
                  :list="allOptions.mc_usage"
                  :disabled="disabledList.includes('usage_ind')&&!isEndorsement||isMotorcycle"
                  @change="handleUpdateMotorOcc" />
              </el-form-item>
            </div>
            <!--            <div-->
            <!--              v-if="formData.usage_ind==2"-->
            <!--              class="form-item">-->
            <!--              <span>What kind of commercial usage</span>-->
            <!--              &lt;!&ndash; <span>In addition to social, domestic, pleasure use and by the proposer for business purposes, will the vehicle be used for</span> &ndash;&gt;-->
            <!--              &lt;!&ndash;              :prop="editType !== 1?'business_purposes':''"&ndash;&gt;-->
            <!--              <el-form-item-->
            <!--                ref="business_purposes"-->
            <!--                prop="business_purposes"-->
            <!--              >-->
            <!--                <v-checkbox-group-->
            <!--                  v-model="formData.business_purposes"-->
            <!--                  :block="true"-->
            <!--                  :list="businessPurposesList"/>-->
            <!--              </el-form-item>-->
            <!--            </div>-->
            <!--            <div class="form-item">-->
            <!--              <span>Are all the driver(s) has not been involved in a motor accident nor deduction of driving offence over 5 points in the past three years?</span>-->
            <!--              <el-form-item-->
            <!--                ref="no_acci_nor_deduct"-->
            <!--                prop="no_acci_nor_deduct">-->
            <!--                <v-radio-group-->
            <!--                  v-model="formData.no_acci_nor_deduct"-->
            <!--                  :border="true"-->
            <!--                  disabled-->
            <!--                  :list="yesNoOptions" />-->
            <!--              </el-form-item>-->
            <!--            </div>-->
            <div class="form-item">
              <span>Are all the driver(s) has not been involved in a motor accident in the past 3 years?</span>
              <el-form-item
                :rules="rules.no_dr_acci_ind"
                prop="no_dr_acci_ind">
                <v-radio-group
                  v-model="formData.no_dr_acci_ind"
                  :border="true"
                  :list="acciOptions"
                  @change="handlerInd"
                />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Are all the driver(s) has not been deducted driving offence points in the past 3 years?</span>
              <el-form-item
                :rules="rules.no_dr_deduct_ind"
                prop="no_dr_deduct_ind">
                <v-radio-group
                  v-model="formData.no_dr_deduct_ind"
                  :border="true"
                  :disabled="false"
                  :list="deductOptions"
                  @change="handlerInd" />
              </el-form-item>
            </div>

          </template>
          <template v-else-if="formData.class_id === 11">
            <div class="form-item">
              <span>Chassis Number</span>
              <el-form-item
                ref="chasis_no"
                prop="chasis_no">
                <v-input
                  v-model="formData.chasis_no"
                  :uppercase="true"/>
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Engine Number</span>
              <el-form-item
                ref="engn_no"
                prop="engn_no">
                <v-input
                  v-model="formData.engn_no"
                  :uppercase="true"/>
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Car Usage</span>
              <el-form-item
                ref="usage_ind"
                prop="usage_ind">
                <v-radio-group
                  v-model="formData.usage_ind"
                  :border="true"
                  :list="usageOptions"
                  :disabled="disabledList.includes('usage_ind')" />
              </el-form-item>
            </div>
            <div
              v-show="formData.usage_ind == 2"
              class="form-item">
              <span>What kind of commercial usage?</span>
              <!-- <span>In addition to social, domestic, pleasure use and by the proposer for business purposes, will the vehicle be used for</span> -->
              <!--              :prop="editType !== 1?'business_purposes':''"-->
              <el-form-item
                ref="business_purposes"
                prop="business_purposes"
              >
                <v-checkbox-group
                  v-model="formData.business_purposes"
                  :block="true"
                  :list="localAllOptions.business_purposes"/>
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Is there any modification in the above vehicle?</span>
              <el-form-item
                ref="car_modified_ind"
                prop="car_modified_ind">
                <v-radio-group
                  v-model="formData.car_modified_ind"
                  :border="true"
                  :list="modifiedOptions" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Is the vehicle fitted with Car Camcorder?</span>
              <el-form-item
                ref="car_camcorder_ind"
                prop="car_camcorder_ind">
                <v-radio-group
                  v-model="formData.car_camcorder_ind"
                  :border="true"
                  :list="installOptions" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Alarm and/ or Global Positioning System installed?</span>
              <el-form-item
                ref="alarm_or_global_ind"
                prop="alarm_or_global_ind">
                <v-radio-group
                  v-model="formData.alarm_or_global_ind"
                  :border="true"
                  :list="installOptions" />
              </el-form-item>
            </div>
            <!--            <div class="form-item">-->
            <!--              <span>Are all the driver(s) has not been involved in a motor accident nor deduction of driving offence over 5 points in the past three years?</span>-->
            <!--              <el-form-item-->
            <!--                ref="no_acci_nor_deduct"-->
            <!--                prop="no_acci_nor_deduct">-->
            <!--                <v-radio-group-->
            <!--                  v-model="formData.no_acci_nor_deduct"-->
            <!--                  :border="true"-->
            <!--                  disabled-->
            <!--                  :list="yesNoOptions" />-->
            <!--              </el-form-item>-->
            <!--            </div>-->
            <div class="form-item">
              <span>Are all the driver(s) has not been involved in a motor accident in the past 3 years?</span>
              <el-form-item
                :rules="rules.no_dr_acci_ind"
                prop="no_dr_acci_ind">
                <v-radio-group
                  v-model="formData.no_dr_acci_ind"
                  :border="true"
                  :disabled="false"
                  :list="acciOptions"
                  @change="handlerInd" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Are all the driver(s) has not been deducted driving offence points in the past 3 years?</span>
              <el-form-item
                :rules="rules.no_dr_deduct_ind"
                prop="no_dr_deduct_ind">
                <v-radio-group
                  v-model="formData.no_dr_deduct_ind"
                  :border="true"
                  :disabled="false"
                  :list="deductOptions"
                  @change="handlerInd" />
              </el-form-item>
            </div>
          </template>
          <template v-else>
            <div class="form-item">
              <span>Permitted Gross Vehicle Weight</span>
              <el-form-item
                ref="tonnage"
                prop="tonnage">
                <v-input
                  v-model="formData.tonnage"
                  money
                  append="tones"
                  @input="tonnageHandleInput"/>
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Seating Capacity ( excl. driver)</span>
              <el-form-item
                ref="no_of_seats"
                prop="no_of_seats">
                <v-input
                  v-model="formData.no_of_seats"
                  :min="1"
                  :max="70"
                  :keyNumber="true"
                  :int="true"
                />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Chassis Number</span>
              <el-form-item
                ref="chasis_no"
                prop="chasis_no">
                <v-input
                  v-model="formData.chasis_no"
                  :uppercase="true"/>
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Engine Number</span>
              <el-form-item
                ref="engn_no"
                prop="engn_no">
                <v-input
                  v-model="formData.engn_no"
                  :uppercase="true"/>
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Is there any modification in the above vehicle?</span>
              <el-form-item
                ref="car_modified_ind"
                prop="car_modified_ind">
                <v-radio-group
                  v-model="formData.car_modified_ind"
                  :border="true"
                  :list="modifiedOptions" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Is the vehicle fitted with Car Camcorder?</span>
              <el-form-item
                ref="car_camcorder_ind"
                prop="car_camcorder_ind">
                <v-radio-group
                  v-model="formData.car_camcorder_ind"
                  :border="true"
                  :list="installOptions" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Will the vehicle be used by third party for carrying goods for reward?</span>
              <el-form-item
                ref="use_carrying_profit_ind"
                prop="use_carrying_profit_ind">
                <v-radio-group
                  v-model="formData.use_carrying_profit_ind"
                  :border="true"
                  :disabled="formData.class_id==12"
                  :list="yesNoOptions" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Alarm and/ or Global Positioning System installed?</span>
              <el-form-item
                ref="alarm_or_global_ind"
                prop="alarm_or_global_ind">
                <v-radio-group
                  v-model="formData.alarm_or_global_ind"
                  :border="true"
                  :list="installOptions" />
              </el-form-item>
            </div>
            <!--            <div class="form-item">-->
            <!--              <span>Are all the driver(s) has not been involved in a motor accident nor deduction of driving offence over 5 points in the past three years?</span>-->
            <!--              <el-form-item-->
            <!--                ref="no_acci_nor_deduct"-->
            <!--                prop="no_acci_nor_deduct">-->
            <!--                <v-radio-group-->
            <!--                  v-model="formData.no_acci_nor_deduct"-->
            <!--                  :border="true"-->
            <!--                  disabled-->
            <!--                  :list="yesNoOptions" />-->
            <!--              </el-form-item>-->
            <!--            </div>-->
            <div class="form-item">
              <span>Are all the driver(s) has not been involved in a motor accident in the past 3 years?</span>
              <el-form-item
                :rules="rules.no_dr_acci_ind"
                prop="no_dr_acci_ind">
                <v-radio-group
                  v-model="formData.no_dr_acci_ind"
                  :border="true"
                  :list="acciOptions"
                  @change="handlerInd" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Are all the driver(s) has not been deducted driving offence points in the past 3 years?</span>
              <el-form-item
                :rules="rules.no_dr_deduct_ind"
                prop="no_dr_deduct_ind">
                <v-radio-group
                  v-model="formData.no_dr_deduct_ind"
                  :border="true"
                  :list="deductOptions"
                  @change="handlerInd" />
              </el-form-item>
            </div>
          </template>
        </div>
      </div>
      <div class="form-item">
        <span>NCD</span>
        <el-form-item
          ref="ncd_pct"
          prop="ncd_pct">
          <v-radio-group
            v-model="formData.ncd_pct"
            :border="true"
            :list="localAllOptions.ncd" />
        </el-form-item>
      </div>
      <div class="tips">
        <p
          v-if="formData.claim_ticket_num === 0"
          class="no-cliam">
          <font-awesome-icon
            icon="check"
            class="check" />
          No claims filed in previous period <br>Previous NCD: {{formData.prev_ncd}}%
        </p>
        <p
          v-if="formData.claim_ticket_num > 0"
          class="has-cliam">
          <font-awesome-icon
            icon="exclamation-circle"
            class="exclamation-circle" />
          {{formData.claim_ticket_num}} claims filed in previous period <br>Previous NCD: {{formData.prev_ncd}}%
        </p>
      </div>
      <div
        v-show="hasNcd"
        :class="{ 'mask': !hasNcd }"
      >
        <div class="flex-sb">
          <div class="form-item form-half">
            <!--            <span>Previous Insurance Company</span>-->
            <span>Previous Insurer</span>
            <el-form-item
              ref="prev_insurer_nm"
              prop="prev_insurer_nm">
              <v-select
                v-model="formData.prev_insurer_nm"
                :disabled="!hasNcd"
                :list="globalOptions.latest_insurance_company" />
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Previous Policy Registration Mark</span>
            <el-form-item
              ref="prev_rgtn_no"
              prop="prev_rgtn_no">
              <v-input
                v-model="formData.prev_rgtn_no"
                :disabled="!hasNcd"
                maxlength="8"
                @input="handleInput" />
            </el-form-item>
          </div>
        </div>
        <div class="flex-sb">
          <div class="form-item form-half">
            <span>Previous Policy Number</span>
            <el-form-item
              ref="prev_pcy_no"
              prop="prev_pcy_no">
              <v-input
                v-model="formData.prev_pcy_no"
                :disabled="!hasNcd" />
            </el-form-item>
          </div>
          <div
            class="form-item form-half extra-checkbox">
            <span>Is the subject Insured vehicle be the same as the one under the previous policy?</span>
            <el-form-item
              ref="is_same_car"
              prop="is_same_car">
              <v-radio-group
                v-model="formData.is_same_car"
                :list="yesNoOptions"
                :border="true"
                :disabled="!hasNcd" />
            </el-form-item>
          </div>
        </div>
        <!--        <div-->
        <!--          v-if="showAgreeQusetion"-->
        <!--          class="flex-sb">-->
        <!--          <div-->
        <!--            class="form-item form-half extra-checkbox">-->
        <!--            <span>As you are the existing client of the selected insurance company, due to the administration requirement, you agree to appoint HoldCover Insurance Brokers Limited to handle the insurance matter with immediate effect, and understand that the policy documents will be ready in 3-5 working days.</span>-->
        <!--            <el-form-item-->
        <!--              ref="is_agree_handle"-->
        <!--              :rules="rules.select"-->
        <!--              prop="is_agree_handle">-->
        <!--              <v-radio-group-->
        <!--                v-model="formData.is_agree_handle"-->
        <!--                :list="agreeOptions"-->
        <!--                :border="true"-->
        <!--                :disabled="!hasNcd" />-->
        <!--            </el-form-item>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </el-form>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import MixinCarRelation from '@/mixins/car-relation'
import {mapActions, mapState} from 'vuex'
// import {
//   getCarQuoteDetail,
//   getHomefireQuoteDetail,
//   getHousemaidQuoteDetail,
//   getInteriorQuoteDetail,
//   getStudentQuoteDetail,
//   getTravelQuoteDetail,
//   getWorkingQuoteDetail,
//   getPersonalQuoteDetail,
// } from '@/api/quote'

export default {
  name: 'InsuredVehicleForm',
  mixins: [MixinOptions, MixinRules,MixinCarRelation],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    disabledList: {
      type: Array,
      default: () => ([])
    },
    formDataLock: {
      type: Number,
      default: 0
    },
    editType:{
      type:Number,
      default:0
    },
    disabled:{
      type:Boolean,
      default:false
    },
    isEndorsement:{
      type:Boolean,
      default:false
    },
    // addRenew:{
    //   type: Boolean,
    //   default: false
    // },
    renewOrderId: {
      type: [Number, String],
      default: 0
    },
  },
  data() {
    const checkBusiness = (rule, value, callback) => {
      const { usage_ind,business_purposes } = this.formData
      const require = this.isRequired && this.requireValid
      if(require && usage_ind == 2 && value.length<=0) {
        callback(new Error(this.$t('placeholder.select')))
      }
      callback()
    }
    const checkMark = (rule, value, callback) => {
      var reg = /^[a-zA-Z0-9][a-zA-Z0-9 ]{0,7}$/
      // var reg = /^[0-9a-zA-Z]{0,8}$/
      let {rgtn_no,already_owned_by_ind} = this.formData
      if(already_owned_by_ind&&!rgtn_no)
        callback(new Error(this.$t('placeholder.input')))
      if(value&&!reg.test(value)){
        callback(new Error('只能輸入字母或者數字'))
      }
      callback()
    }
    const checkEngnRequired = (rule, value, callback) => {
      const valueResult = value !== null && value !== ''
      var reg = /^[0-9]{1,4}$/
      var reg11 = /[1-9][0-9]{0,4}$/
      const { class_id,brand_id } = this.formData
      if(class_id==14 ){
        if((!valueResult||!reg.test(value)))
          callback(new Error('最多只允許輸入5位數字'))
      }else{
        let data = ''
        this.allOptions11.brand.forEach(item => {
          if (item.id == brand_id)
            data = item
        })
        if (!reg11.test(value) && data.is_motor !== 1) {
          callback(new Error('最多只允許輸入5位數字，並且不能小於1'))
        }else{
          if(class_id==11){
            if(this.isElectric&&!valueResult){
              callback()
            }
            else if(!valueResult||!reg.test(value))
              callback(new Error('最多只允許輸入5位數字'))
          }
          else if(!valueResult||!reg.test(value))
            callback(new Error('最多只允許輸入5位數字'))

        }
      }
      callback()
      // if(class_id==14 &&value<=0||!valueResult&&class_id==14) {
      //   callback(new Error('數值必需大於0 '))
      // }else {
      //   let data = ''
      //   this.allOptions11.brand.forEach(item => {
      //     if (item.id == brand_id)
      //       data = item
      //   })
      //   if (value<=0 && data.is_motor !== 1) {
      //     callback(new Error('數值不得小於1 '))
      //   }else{
      //     if (!valueResult)
      //       callback(new Error(this.$t('placeholder.input')))
      //   }
      //   callback()
      // }
    }
    const checkncdRequired = (rule, value, callback) => {
      const valueResult = value !== null && value !== ''
      const { class_id } = this.formData
      // 一個用於組件内，一個用於父組件
      const require = this.isRequired && this.requireValid
      if(require && this.hasNcd && !valueResult) {
        callback(new Error(this.$t('placeholder.input')))
      }
      callback()
    }
    const checkNcdPct = (rule, value, callback) => {
      const valueResult = value !== null && value !== '' && value != -1
      if(!valueResult) {
        callback(new Error(this.$t('placeholder.input')))
      }
      callback()
    }
    const checkncdSelRequired = (rule, value, callback) => {
      const valueResult = value !== null && value !== '' && value != '-1'
      const { class_id } = this.formData
      // 一個用於組件内，一個用於父組件
      const require = this.isRequired && this.requireValid
      if(require && this.hasNcd && !valueResult) {
        callback(new Error(this.$t('placeholder.select')))
      }
      callback()
    }
    const checkSeating = (rule, value, callback) => {
      const valueResult = value !== null && value !== ''
      // const { field } = rule
      var reg = /^[012]\d{0}$/
      var reg11 = /^[1223456789]\d{0}$/
      var reg12 = /^7[0]$|^[1-6]\d$|^[1-9]$/
      const { class_id,no_of_seats } = this.formData
      let require = this.isRequired&&!no_of_seats
      if(class_id==14 &&value&&!reg.test(no_of_seats)||class_id==14&&require) {
        callback(new Error('輸入範圍是 0～2 '))
      }
      if(class_id==11 &&value&&!reg11.test(no_of_seats)||class_id==11&&require) {
        callback(new Error('輸入範圍是 1～9 '))
      }
      if(class_id==12 &&value&&!reg12.test(no_of_seats)||class_id==12&&require) {
        callback(new Error('輸入範圍是 1～70  '))
      }
      callback()
    }
    const checkTones = (rule, value ,cb) => {
      if(value && value > 999.99){
        cb(new Error('輸入範圍是 0～999.99 '))
      }
      if(this.editType == 2 && !value){
        cb(new Error(this.$t('placeholder.input')))
      }
      cb()
    }
    return {
      coverTypeOption:[
        {
          id: 1,
          name: 'Third Party',
          disable:false
        },
        {
          id: 2,
          name: 'Comprehensive',
          disable:true
        },
      ],
      formData: {
        class_id: '',
        already_owned_by_ind: '',
        rgtn_no: '',
        usage_ind: '',
        brand_id: '',
        rgtn_mdl: '',
        typ_of_bdy_id: '',
        is_same_car:'',
        // no_acci_nor_deduct: '',
        no_dr_acci_ind:'',
        no_dr_deduct_ind:'',
        rgtn_typ_of_bdy: '',
        rgtn_yr: '',
        engn_cpcty: '',
        ncd_pct: '',
        no_of_seats: '',
        chasis_no: '',
        engn_no: '',
        trm_of_cvr: '',
        car_modified_ind: '',
        car_camcorder_ind: '',
        business_purposes: [],
        prev_insurer_nm: '',
        prev_rgtn_no: '',
        prev_pcy_no: '',
        model_id: '',
        tonnage: '',
        alarm_or_global_ind: '', // new
        use_carrying_profit_ind: '',
        claim_ticket_num: '',
        prev_ncd: '',
        // is_agree_handle:-1
      },
      questionOptions: [
        {
          name: 'Social domestic and pleasure purposes',
          id: 1
        },
        {
          name: 'Hire or reward',
          id: 2
        },
        {
          name: 'Motor trade',
          id: 3
        },
        {
          name: 'Driving instruction purposes',
          id: 4
        }
      ],
      formKey14: {
        already_owned_by_ind: '',
        rgtn_no: '',
        class_id: '',
        usage_ind: '',
        brand_id: 0,
        rgtn_mdl: '',
        typ_of_bdy_id: '',
        is_same_car:'',
        // no_acci_nor_deduct: '',
        no_dr_acci_ind:'',
        no_dr_deduct_ind:'',
        rgtn_yr: '',
        engn_cpcty: '',
        no_of_seats: '',
        chasis_no: '',
        engn_no: '',
        trm_of_cvr: '',
        car_modified_ind: '',
        car_camcorder_ind: '',
        business_purposes: [],
        ncd_pct: '',
        prev_insurer_nm: '',
        prev_rgtn_no: '',
        prev_pcy_no: '',
        // is_agree_handle:-1
      },
      formKey11: {
        already_owned_by_ind: '',
        rgtn_no: '',
        rgtn_yr: '',
        brand_id: '',
        model_id: '',
        typ_of_bdy_id: '',
        is_same_car:'',
        // no_acci_nor_deduct: '',
        no_dr_acci_ind:'',
        no_dr_deduct_ind:'',
        engn_cpcty: '',
        no_of_seats: '',
        chasis_no: '',
        engn_no: '',
        usage_ind: '',
        car_modified_ind: '',
        business_purposes: [],
        car_camcorder_ind: '',
        ncd_pct: '',
        prev_insurer_nm: '',
        prev_rgtn_no: '',
        prev_pcy_no: '',
        alarm_or_global_ind: '', // new
        rgtn_mdl:'',
        // is_agree_handle:-1
      },
      formKey12: {
        already_owned_by_ind: '',
        rgtn_no: '',
        rgtn_yr: '',
        brand_id: '',
        rgtn_mdl: '',
        typ_of_bdy_id: '',
        is_same_car:'',
        // no_acci_nor_deduct: '',
        no_dr_acci_ind:'',
        no_dr_deduct_ind:'',
        rgtn_typ_of_bdy: '',
        engn_cpcty: '',
        tonnage: '',
        no_of_seats: '',
        chasis_no: '',
        engn_no: '',
        car_modified_ind: '',
        car_camcorder_ind: '',
        ncd_pct: '',
        prev_insurer_nm: '',
        prev_rgtn_no: '',
        prev_pcy_no: '',
        alarm_or_global_ind: '', // new
        use_carrying_profit_ind: '',
        // is_agree_handle:-1
      },
      extraRules: {
        engn_cpcty: [
          { validator: checkEngnRequired, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        prev_insurer_nm: [
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          { validator: checkncdSelRequired, trigger: ['change', 'blur'] }
        ],
        ncd_pct: [
          {validator: checkNcdPct, trigger: ['change']}
        ],
        prev_pcy_no: [
          { validator: checkncdRequired, trigger: ['change', 'blur'] }
        ],
        is_same_car: [
          { validator: checkncdSelRequired, trigger: ['change', 'blur'] }
        ],
        prev_rgtn_no: [
          { validator: checkncdRequired, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        business_purposes: [
          { validator: checkBusiness, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        no_of_seats: [
          { validator: checkSeating, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        rgtn_no: [
          { validator: checkMark, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        tonnage:[
          {validator: checkTones, trigger: ['change', 'blur']}
        ]
      },
      oldFormDataLock: -1
    }
  },
  computed: {
    ...mapState('quote', ['carModelOptions']),
    ...mapState('common', ['productId']),
    ...mapState('errorfield', ['errorField']),
    isShowQuestion(){
      let {prev_insurer_nm} = this.formData||{}
      let {company_id} = this.form||{}
      let pre_insurance = this.globalOptions.latest_insurance_company||[]
      pre_insurance =pre_insurance.filter(item=> item.id == prev_insurer_nm)
      if(pre_insurance.length>0)
      {
        return  pre_insurance[0].hc_cp_id==company_id
      }else
        return false
    },
    showAgreeQusetion(){
      let {company_id} = this.form
      let {prev_insurer_nm,is_same_car} = this.formData||{}
      return this.isShowQuestion&&is_same_car==1
    },
    hasNcd() {
      return this.formData.ncd_pct == 0 || this.formData.ncd_pct == null? false: true
    },
    classId() {
      return this.formData.class_id || 14
    },
    localAllOptions() {
      if(this.classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${this.classId}`]
      }
    },
    businessPurposesList(){
      let list = this.localAllOptions.business_purposes||[]
      return list.filter(item=>item.status==1)
    },
    isDisable(){
      let {tonnage=-1} = this.formData
      return tonnage == 5.5
    },
    bodyTypeList(){
      // let list  = JSON.parse(JSON.stringify(this.localAllOptions.typ_of_bdy))
      // let {typ_of_bdy_id=-1,tonnage} = this.formData
      // if(typ_of_bdy_id == 0)
      // {
      //   list = list.filter(item=>{
      //     return item.id!=42
      //   })
      // }
      // if(typ_of_bdy_id==42)
      // {
      //   list = list.filter(item=>{
      //     return item.id==42
      //   })
      // }
      // return  list
      return this.allOptions12.typ_of_bdy
    },
    isMotorcycle(){
      return false
      return this.classId==14
    },
    isPrivate(){
      return false
      return this.classId==11
    },
    isCommercial(){
      return this.classId==12
    },
    isElectric(){
      let list = this.carModelOptions||[]
      let {model_id} = this.formData||{}
      let arr = []
      let obj = {}
      if(model_id){
        arr = list.filter(item=>item.id==model_id)
      }
      obj = arr.length>0?arr[0]:{}
      return obj.is_electric_car==1||false
    }
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    form: {
      deep: true,
      immediate: true,
      async  handler(val) {
        if(this.formDataLock !== this.oldFormDataLock) {
          this.oldFormDataLock = this.formDataLock
          Object.keys(this.formData).some(key => {
            if(key in val) {
              if(this.classId == 12 && key == 'tonnage' && Number(val[key]) == -1) {
                this.formData[key] = ''
              }
              else {
                this.formData[key] = val[key]
              }
            }
          })
          let {typ_of_bdy_id=-1,tonnage} = val
          if(typ_of_bdy_id==0)
            this.formData.tonnage = 5.5
          else{
            if(tonnage<=0)
              this.formData.tonnage = ''
          }
          if(this.classId==11){
            await this.getCarYearRelation()
            this.formData.rgtn_yr = val.rgtn_yr
            await this.getCarRelation()
          }

        }
      }
    },
    'formData.brand_id': {
      immediate: true,
      deep: true,
      handler(val, old) {
        if(val && this.formData.class_id == 11) {
          this.updateCarModelOptions({
            val,
            time: new Date().getTime()
          })
        }
      }
    },
    'formData.ncd_pct': {
      immediate: true,
      deep: true,
      handler(val) {
        if(this.editType != 3){
          this.$emit('get-data', {
            key: 'ncd_pct',
            value: val
          })
        }
      }
    },
    'formData.tonnage':{
      immediate: true,
      handler(val) {
        if(val<=0)
        {
          setTimeout(()=>{
            this.formData.tonnage = ''
          },50)
        }
      },
    },
    errorField:{
      immediate:true,
      handler(val){
        // console.log('val====',val)
        if(val)
        {
          // this.errScrollToValidDom(val)
        }
      }
    },
    'formData.rgtn_no':{
      immediate:true,
      handler(val){
        if(val){
          this.formData.rgtn_no = val.trim()
        }
      }
    },
    'formData.model_id':{
      immediate:true,
      handler(val,old){
        this.$nextTick(()=>{
          this.$refs.form.clearValidate('engn_cpcty')
        })
      }
    }
  },
  // mounted(){
  //   if(this.editType == 3 && !this.addRenew){
  //     this.updateQuoteDetailData()
  //   }
  // },
  methods: {
    ...mapActions('quote', ['updateCarModelOptions']),
    ...mapActions('errorfield', ['setErrorData']),
    handleUpdateMotorOcc(){
      let {usage_ind} = this.formData
      this.$emit('update:usageInd',usage_ind)
    },
    handleOwned(){
      let {already_owned_by_ind} = this.formData||{}
      this.$emit('already-owned',already_owned_by_ind)
    },
    tonnageHandleInput(val){
      this.$emit('getTon',val)
    },
    handleInput(val){
      this.formData.prev_rgtn_no = val.toUpperCase()
    },
    handlerInd(){
      let {no_dr_acci_ind,no_dr_deduct_ind} = this.formData||{}
      let question = {no_dr_acci_ind,no_dr_deduct_ind}
      this.$emit('handleInd',question)
    },
    handlerExtraModel(){
      let {model_id} = this.formData||{}
      this.$refs.form.clearValidate('engn_cpcty')
      this.getCarYearRelation()
      this.$emit('handleModel',model_id)
    },
    submitForm(formName) {
      this.$refs.form.validate((valid, rules) => {
        if(valid) {
          //
          const classId = this.formData.class_id || 14
          // 根據 form key整合數據
          let formResult = this[`formKey${classId}`]
          Object.keys(formResult).some(key => {
            formResult[key] = this.formData[key]
          })
          let {typ_of_bdy_id} = this.formData
          if(classId==11&&!typ_of_bdy_id){
            formResult.typ_of_bdy_id = 0
          }
          this.$emit('getFormData', formName, formResult)
        }
        else {
          this.scrollToValidDom(rules)
        }
      })

    },
    getSaveSubmitForm(formName){
      const classId = this.formData.class_id || 14
      // 根據 form key整合數據
      let formResult = this[`formKey${classId}`]
      Object.keys(formResult).some(key => {
        formResult[key] = this.formData[key]
      })
      let {typ_of_bdy_id} = this.formData
      if(classId==11&&!typ_of_bdy_id){
        formResult.typ_of_bdy_id = 0
      }
      this.$emit('getFormData', formName, formResult)
    },
    // updateQuoteDetailData(){
    //   switch (Number(this.productId)) {
    //     case 12:
    //       this.network().getHousemaidQuoteDetail({
    //         hideLoading: true
    //       })
    //       break
    //     case 11:
    //       this.network().getCarQuoteDetail({
    //         hideLoading: true
    //       })
    //       break
    //     case 13:
    //       this.network().getWorkingQuoteDetail({
    //         hideLoading: true
    //       })
    //       break
    //     case 14:
    //       this.network().getTravelQuoteDetail({
    //         hideLoading: true
    //       })
    //       break
    //     case 15:
    //       this.network().getInteriorQuoteDetail({
    //         hideLoading: true
    //       })
    //       break
    //     case 16:
    //       this.network().getStudentQuoteDetail({
    //         hideLoading: true
    //       })
    //       break
    //     case 17:
    //       this.network().getHomefireQuoteDetail({
    //         hideLoading: true
    //       })
    //       break
    //     case 18:
    //       this.network().getPersonalQuoteDetail({
    //         hideLoading: true
    //       })
    //       break
    //     case 20:
    //       this.network().getHomefireQuoteDetail({
    //         hideLoading: true
    //       })
    //       break
    //   }
    // },

    // network(){
    //   return{
    //     // quote detail
    //     getCarQuoteDetail: async (params) => {
    //       const {data} = await getCarQuoteDetail({
    //         order_id: this.renewOrderId,
    //         ...params
    //       })
    //       this.formData = data
    //     },
    //     getHousemaidQuoteDetail: async (params) => {
    //       const {data} = await getHousemaidQuoteDetail({
    //         order_id: this.renewOrderId,
    //         ...params
    //       })
    //       this.formData = data
    //     },
    //     getInteriorQuoteDetail: async (params) => {
    //       const {data} = await getInteriorQuoteDetail({
    //         order_id: this.renewOrderId,
    //         ...params
    //       })
    //       this.formData = data
    //     },
    //     getHomefireQuoteDetail: async (params) => {
    //       const {data} = await getHomefireQuoteDetail({
    //         order_id: this.renewOrderId,
    //         ...params
    //       })
    //       this.formData = data
    //     },
    //     getTravelQuoteDetail: async (params) => {
    //       const {data} = await getTravelQuoteDetail({
    //         order_id: this.renewOrderId,
    //         ...params
    //       })
    //       this.formData = data
    //     },
    //     getStudentQuoteDetail: async (params) => {
    //       const {data} = await getStudentQuoteDetail({
    //         order_id: this.renewOrderId,
    //         ...params
    //       })
    //       this.formData = data
    //     },
    //     getWorkingQuoteDetail: async (params) => {
    //       const {data} = await getWorkingQuoteDetail({
    //         order_id: this.renewOrderId,
    //         ...params
    //       })
    //       this.formData = data
    //     },
    //     getPersonalQuoteDetail: async (params) => {
    //       const {data} = await getPersonalQuoteDetail({
    //         order_id: this.renewOrderId,
    //         ...params
    //       })
    //       this.formData = data
    //     },
    //   }
    // }
  }
}
</script>
<style lang="scss" scoped>
.span-tips{
  color: #24292E;
  font-weight: 400;
  font-size: 12px;
  margin-bottom: 5px;
  display: inline-block;
}
.padding-bottom-0{
  padding-bottom: 0!important;
}
.tips{
  display: inline-block;
  margin-bottom: 20px;
  p{
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 15px;
    gap: 15px;
    width: 330px;
    height: 70px;
    border-radius: 6px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #24292E;
  }
  .no-cliam{
    background: #DCFFE4;
    border: 1px solid rgba(23, 111, 44, 0.2);
    .check{
      font-weight: 900;
      font-size: 14px;
      line-height: 16px;
      color: #22863A;
    }
  }
  .has-cliam{
    background: #FFFBDD;
    border: 1px solid rgba(176, 136, 0, 0.2);
    .exclamation-circle{
      font-weight: 900;
      font-size: 14px;
      line-height: 16px;
      color: #B08800;
    }
  }
}
.insured-vehicle-form {
    // display: flex;
    // justify-content: space-between;
    // .form-left, .form-right {
    //     width: calc(50% - 10px);
    // }
    .mask {
      opacity: .2;
    }
  .extra-checkbox{
    .el-checkbox-group{
      flex-direction: column;
      align-items: flex-start;
    }
  }
}
</style>
